import { cachedEndpointCall } from '@atlassian/jira-onboarding-core/src/services/cached-endpoint/index.tsx';
import { getOnboardingPremiumTrialWithRethrow } from '../../services/get-onboarding-premium-trial/index.tsx';

const getPremiumTrialOnSignup = cachedEndpointCall(getOnboardingPremiumTrialWithRethrow);

export const actions = { getPremiumTrialOnSignup };
